.root {
  position: relative;

  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 1.25rem;
  height: 1.25rem;

  vertical-align: middle;
}

.icon {
  position: absolute;
  width: 100%;
  height: 100%;
}

.title {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);

  font-size: 0.75em;
  font-weight: var(--font-weight-medium);
  line-height: 1;
  color: #ffffff;

  :global(.emoji) {
    width: 1em;
    height: 1em;
  }
}
